import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: '700',
    lineHeight: '1.2',
  },
  subtitle: {
    fontWeight: '600',
    lineHeight: '1.2',
  },
  cursoItem: {
    display: 'flex',
    margin: `${theme.spacing(1)}px 0`,
  },
  cursoCard: {
    backgroundColor: theme.palette.action.hover,
    borderRadius: '24px 0',
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    width: '100%',
  },
  cursoTitle: {
    margin: 'auto 0',
  },
  cursoBtn: {
    alignSelf: 'flex-end',
    margin: '8px 0 -24px 0',
    minWidth: 120,
  },
}));

export default useStyles;
